module.exports = __webpack_public_path__ + "img/usina-solo.2a3e5956.jpg";